import { render, staticRenderFns } from "./RemessaOperacoes.vue?vue&type=template&id=9c2e7672"
import script from "./RemessaOperacoes.vue?vue&type=script&lang=js"
export * from "./RemessaOperacoes.vue?vue&type=script&lang=js"
import style0 from "./RemessaOperacoes.vue?vue&type=style&index=0&id=9c2e7672&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports